import { RG_TYPE as i } from "@project-rouge/rg-core";
import { getCountOfType as f } from "../../counting/index.js";
import { getRgObjectsAtLevel as a } from "../../../utils/rg-util/index3.js";
const C = (t, o) => {
  const n = f(t, i.Apartment, o), e = a(t, i.Core, o).filter((r) => r.data.hasFireLift || r.data.hasNonFireLift).length;
  return e !== 0 ? n / e : 0;
};
export {
  C as getLevelUnitToLiftCoreRatio
};
//# sourceMappingURL=index34.js.map
